import type { Location } from 'react-router-dom'

interface UseNavigationUtilsParams {
    /** Location object from router (required for dependency injection) */
    location: Location
}

export function useNavigationUtils({ location }: UseNavigationUtilsParams) {
    const isActive = (path: string) => {
        return location.pathname === path
    }

    const isLessonPage = () => {
        return location.pathname.startsWith('/lesson')
    }

    return { isActive, isLessonPage }
}
